import { createContext, useEffect, useState } from "react";
import Nav from "./components/nav";

import Greet from "./dateTime";
import Footer from "./footer";

import Loading from "./loading";
import ReactSwitch from "react-switch";
import Home from "./home";
import Skill from "./skill";
import Projects from "./projects";
import Contact from "./components/contact";
// import About from "./About";
export const ThemeContext = createContext(null);
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);
  const [theme, setTheme] = useState("dark");
  const togglertheme = () => {
    setTheme((curr) => (curr === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, togglertheme }}>
      <div className="app" id={theme}>
        {loading ? (
          <Loading />
        ) : (
          <main>
            <Nav />
            <Home />
            <Skill />
            <Projects />
            <Contact />
            {/* <center> */}
            <div style={{ marginTop: "10px" }}>
              <label
                style={{
                  padding: "5px",
                  fontSize: "13px",
                  textTransform: "capitalize",
                  position: "relative",
                  bottom: "10px",
                }}
              >
                {theme === "dark" ? "" : ""}
              </label>
              {/* <ReactSwitch onChange={togglertheme} checked={theme === "dark"} /> */}
            </div>
            {/* </center> */}
          </main>
        )}
      </div>
    </ThemeContext.Provider>
  );
}
export default App;
